module.exports = __webpack_public_path__ + "img/Autocolant TSH_55mm x 60mm-01.936e4419.jpg";